import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {PreferenceFrequency} from "../../services/preferenceTypes";
import {findTranslationValue} from "./util";
import { Input, Select } from '@chapche/ui';

const createFrequencyPeriodType = (frequencyType, frequencyPeriod) => {
    if(frequencyType === PreferenceFrequency.NO_MATTER || frequencyPeriod > 2) {
        return frequencyType;
    }
    if(frequencyType === PreferenceFrequency.ONCE_A_PERIOD && frequencyPeriod === 1) {
        return PreferenceFrequency.EVERY_DAY;
    }
    if(frequencyType === PreferenceFrequency.ONCE_A_PERIOD && frequencyPeriod === 2) {
        return PreferenceFrequency.DAY_AFTER_DAY;
    }
};

const PreferenceStructureItemHowOften = ({ itemSaveService }) => {
    const { i18n } = useTranslation();
    const [frequencyPeriod, setFrequencyPeriod] = useState(+itemSaveService.getPreference().frequencyPeriod);
    const [frequencyType, setFrequencyType] = useState(createFrequencyPeriodType(itemSaveService.getPreference().preferenceFrequency, 
        +itemSaveService.getPreference().frequencyPeriod));
    const [error, setError] = useState(false);

    const createListOfOptions = () => {
        return [
            {
                value: PreferenceFrequency.NO_MATTER,
                label: i18n.t(`preference.scheme.frequency.${PreferenceFrequency.NO_MATTER}`),
            },
            {
                value: PreferenceFrequency.EVERY_DAY,
                label: i18n.t(`preference.scheme.frequency.${PreferenceFrequency.EVERY_DAY}`),
            },
            {
                value: PreferenceFrequency.DAY_AFTER_DAY,
                label: i18n.t(`preference.scheme.frequency.${PreferenceFrequency.DAY_AFTER_DAY}`),
            },
            {
                value: PreferenceFrequency.ONCE_A_PERIOD,
                label: `${i18n.t(`preference.scheme.frequency.${PreferenceFrequency.ONCE_IN_DAYS}`)} N ${findTranslationValue(5, i18n)}`,
            },
        ];
    };

    const changeFrequencyValue = (e) => {
        setError(false);
        setFrequencyPeriod(e.target.value);
        if(+e.target.value > 0 && +e.target.value < 15) {    
            updatePreferenceValue(frequencyType, +e.target.value);
        } else {
            setError(true);
        }
    };

    const updatePreferenceValue = (value, period = null) => {
        setFrequencyType(value);
        if(value === PreferenceFrequency.EVERY_DAY) {
            itemSaveService.updateHowOften(PreferenceFrequency.ONCE_A_PERIOD, 1);
        } else if (value === PreferenceFrequency.DAY_AFTER_DAY) {
            itemSaveService.updateHowOften(PreferenceFrequency.ONCE_A_PERIOD, 2);
        } else {
            itemSaveService.updateHowOften(value, period ? period : +frequencyPeriod);
        }
    };

    return (
        <>
            <label className="block__text preference__form-label">
                <span>{i18n.t('app.page.preference.addTitles.howOften')}</span>
                <Select
                    fullWidth
                    className="mt-0"
                    value={frequencyType}
                    options={createListOfOptions()}
                    onChange={updatePreferenceValue}
                />
                {frequencyType ===  PreferenceFrequency.ONCE_A_PERIOD ?
                    <label className="preference__frequency-label">
                        <p className="block__text preference__frequency-title">{i18n.t('app.page.preference.daysCount')}</p>
                        <Input
                            fullWidth
                            className="mt-0"
                            placeholder={i18n.t('app.page.preference.enterInfo')}
                            onChange={changeFrequencyValue}
                            value={frequencyPeriod || ''}
                            errorText={error ? `${i18n.t('product.scheme.property.code.from')} 1 ${i18n.t('product.scheme.property.code.to')} 14` : undefined} />
                    </label>
                    :
                    null
                }
            </label> 
        </>
    );
};

export default PreferenceStructureItemHowOften;
